import { render } from "./FileInTree.vue?vue&type=template&id=494c65da&scoped=true"
import script from "./FileInTree.vue?vue&type=script&lang=js"
export * from "./FileInTree.vue?vue&type=script&lang=js"

import "./FileInTree.vue?vue&type=style&index=0&id=494c65da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-494c65da"

export default script